import React,{useEffect} from "react";

import amico from "./../assets/login/amico.svg";
import vector from "./../assets/login/Vector.png";
import vector2 from "./../assets/login/Vector2.png";
import quote from "./../assets/login/quote.png";
import bg from "./../assets/bg.png"

import { Fragment, useState } from "react";
import LoginForm from "./../components/AuthModals/LoginForm";
import InfoForm from "./../components/AuthModals/InfoForm";
import ForgotPasswordForm from "./../components/AuthModals/ForgotPasswordForm";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const LoginFlow = (props) => {
  const [swap, setSwap] = useState("login");

  useEffect(() => {
    initPixel()
    initGA()
  }, [])

  // const path = props.location.state.from.pathname;
  console.log(props)
  return (
    <Fragment>
      <div className="loginflow">
        <div className="row">
          <div className="col-md-6 order-1">
            {/* <h1 className="ml-5 logintitle">Log in</h1>
            <hr/> */}

            {swap === "login" ? (
              props?
              <LoginForm setSwap={setSwap} pathname={props.location.state}/>
              :
              <LoginForm setSwap={setSwap}/>

            ) : swap === "forgotpassword" ? (
              <ForgotPasswordForm />
            ) : (
              ""
            )}
          </div>

          <div style={{ position: "relative" }} className="col-md-6 order-2 order-md-1 order-lg-1 d-flex flex-column justify-content-center">
            <div className="quote-container" >
              <img className="quote-img" src={quote} alt="quote"/>
              <h3 className="quote ml-4">Firstly, I would like to thank Clapingo. You are doing an extraordinary job in delivering the skills. Moreover, the personal attention was too good in my perspective. Keep going.</h3>
              <h5 className="name ml-4 mt-5">Prashanth</h5>
              <p className="subti ml-4">Hyderabad</p>
            </div>
            <div className="img-container">
            <img style={{ position: "absolute", left: "0", bottom:"-80px", height:"130px" }} src={vector} />
            <img style={{ position: "absolute", left: "150px", bottom:"-80px", height:"130px" }} src={vector2} />
            </div>
          </div>

        </div>

      </div>
    </Fragment>
  )
}

export default LoginFlow;